import admin_console from './admin-console/index.js';
import demo_app from './demo-app.js';
const translation = {
    admin_console,
    demo_app,
};
export default translation;
